import DashboardIcon from "@mui/icons-material/Dashboard";
import { extendTheme } from "@mui/material";
import ModeOfTravelIcon from "@mui/icons-material/ModeOfTravel";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import HealingSharpIcon from "@mui/icons-material/HealingSharp";
import PsychologySharpIcon from "@mui/icons-material/PsychologySharp";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import GroupIcon from "@mui/icons-material/Group";
import { LocalOffer } from "@mui/icons-material";
import EmergencyShareIcon from "@mui/icons-material/EmergencyShare";

export const NAVIGATION = [
  {
    kind: "header",
    title: "Barra de navegación",
  },
  {
    segment: "dashboard/history",
    title: "Mi progreso",
    icon: <DashboardIcon />,
  },
  {
    segment: "dashboard/rutasComplete",
    title: "Mis rutas",
    icon: <ModeOfTravelIcon />,
  },
  {
    segment: "dashboard/public-routes",
    title: "Rutas de la comunidad",
    icon: <EmergencyShareIcon />,
  },
  // {
  //   segment: "dashboard/communities",
  //   title: "Comunidades",
  //   icon: <Diversity3Icon />,
  // },
  {
    segment: "dashboard/runnings-clubs",
    title: "Clubs de corredores",
    icon: <GroupIcon />,
  },
  {
    segment: "dashboard/offerts",
    title: "Ofertas",
    icon: <LocalOffer />,
  },
  {
    kind: "divider",
  },
  {
    kind: "header",
    title: "Bienestar",
  },

  {
    segment: "dashboard/nutricionist-user",
    title: "Nutrición",
    icon: <RestaurantIcon />,
  },
  {
    segment: "dashboard/physiotherapy-user",
    title: "Fisioterapia",
    icon: <HealingSharpIcon />,
  },
  {
    segment: "dashboard/psicology-user",
    title: "Psicología",
    icon: <PsychologySharpIcon />,
  },

  {
    segment: "dashboard/training-user",
    title: "Entrenamientos",
    icon: <DirectionsRunIcon />,
  },
];
export const demoTheme = extendTheme({
  colorSchemes: { dark: true },

  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "rgba(212, 216, 216, 0.32)",
            "& .MuiListItemIcon-root, & .MuiSvgIcon-root": {
              color: "#e7ef7d !important",
            },
          },
        },
      },
    },
  },
});
